export const DRAWER_WIDTH = 280;
export const TABLE_ROWS_PER_PAGE_OPTIONS = [25, 50, 100];
export const ALL = "all";
export const CURRENCY = "AED";